/**
 * HQ 구독 동의 현황 서비스 (2026-10-27, 대표 전용 — 백엔드에서 hq_admin 게이트).
 * 새 이용약관·요금(2026-11-01 시행)에 매장별로 동의·신청했는지 본다.
 * 2026-10-28: 베이직 정가 월 500,000원 · 기존 매장 프로모션 300,000원 — [확인] 때 매장 요금(할인)을 같이 정한다.
 * 2026-10-27 23시: 원장의 베이직 신청을 본부가 [확인] 처리(상태 기록만).
 */
import hqApi from './hqApiClient';

export interface StorePrice {
  list_price: number;
  discount_amount: number;
  discount_label: string | null;
  monthly_fee: number;
  fee_label: string;
  list_fee_label: string;
  is_existing_store: boolean;
  is_custom: boolean;
}

export interface SubscriptionConsentStore {
  organization_id: string;
  organization_name: string;
  owner_name: string | null;
  owner_phone: string | null;
  owner_email: string | null;
  excluded_reason: string | null;
  agreed: boolean;
  agreed_by_name: string | null;
  agreed_by_email: string | null;
  agreed_at: string | null;
  agreed_ip: string | null;
  agreed_via: string | null;
  /** 동의한 약관 판 — 옛 판(terms-2026-11-01) 동의도 완료로 본다 */
  agreed_version?: string | null;
  /** 이 매장 요금(정가·할인·실제 금액) */
  price?: StorePrice | null;
  /** 원장의 베이직 신청 — null(미신청) / requested(확인 대기) / confirmed(본부 확인) */
  request_status: 'requested' | 'confirmed' | null;
  requested_at: string | null;
  requested_by_name: string | null;
  confirmed_at: string | null;
}

export interface SubscriptionConsentList {
  version: string;
  effective_date: string;
  plan_name: string;
  fee_label: string;
  list_price?: number;
  existing_promo_fee?: number;
  default_promo_label?: string;
  previous_versions?: string[];
  summary: {
    targets: number;
    agreed: number;
    not_agreed: number;
    excluded: number;
    requested: number;
    awaiting_confirm: number;
    not_requested: number;
  };
  stores: SubscriptionConsentStore[];
}

const hqSubscriptionConsentService = {
  async list(): Promise<SubscriptionConsentList> {
    const { data } = await hqApi.get<SubscriptionConsentList>('/api/v1/hq/subscription-consents');
    return data;
  },
  /** 베이직 신청 [확인] — 상태 기록만(청구·기능 변경 없음) */
  async confirm(
    organizationId: string,
    price?: { list_price: number; monthly_fee: number; discount_label: string | null },
  ): Promise<void> {
    await hqApi.post(`/api/v1/hq/subscription-consents/${encodeURIComponent(organizationId)}/confirm`, price);
  },
};

export default hqSubscriptionConsentService;
